//@ts-nocheck
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  TextField,
  Grid,
  Button,
  IconButton,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Checkbox,
  FormControlLabel,
  DialogActions,
  Tooltip,
  Stack,
} from "@mui/material";
import MDButton from "../../../../components/MDButton";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Delete,
  DriveFileRenameOutline,
  Edit,
  EditNote,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import { useSubmissionStore } from "../../../../models/applications/SubmissionStore";
import { SelectChangeEvent } from "@mui/material";
import { states, provinces, countries, getStatesProvinces, getStateProvinceLabel, getZipPostalLabel, validateZipOrPostalCode } from "../../../../utils/States";
import { post, get } from "requests";
import { useMerchantContext } from "./MerchantContext";
import Accounts from "layouts/pages/account/settings/components/Accounts";
import MDTypography from "components/MDTypography";

interface AffiliatedBusinessFormProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData: any | null;
}

const AffiliatedBusinessForm: React.FC<AffiliatedBusinessFormProps> = ({
  open,
  onClose,
  onSave,
  initialData,
}) => {
  const { selectedCountry } = useMerchantContext();
  const [formData, setFormData] = useState({
    id: "",
    businessLegalName: "",
    federalTaxId: "",
    country: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    mailingAddress: "",
    mailingCity: "",
    mailingState: "",
    mailingZip: "",
    dba: "",
    legalEntity: "",
    isSeller: false,
    primaryOwner: "",
    accounts: [],
  });

  const [errors, setErrors] = useState({
    businessLegalName: false,
    federalTaxId: false,
    country: false,
    address: false,
    city: false,
    state: false,
    zip: false,
    mailingAddress: false,
    mailingCity: false,
    mailingState: false,
    mailingZip: false,
    dba: false,
    legalEntity: false,
    primaryOwner: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    businessLegalName: "",
    federalTaxId: "",
    country: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    mailingAddress: "",
    mailingCity: "",
    mailingState: "",
    mailingZip: "",
    dba: "",
    legalEntity: "",
    primaryOwner: "",
  });

  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const [mailingStateDropdownOpen, setMailingStateDropdownOpen] = useState(false);
  const [primaryOwnerDropdownOpen, setPrimaryOwnerDropdownOpen] = useState(false);
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [sameAsPhysical, setSameAsPhysical] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  const [showAccountForm, setShowAccountForm] = useState(false);
  const [isAccountEditMode, setIsAccountEditMode] = useState(false);
  const [currentAccount, setCurrentAccount] = useState(null);
  const [accountEditIndex, setAccountEditIndex] = useState(null);

  const {
    affiliatedBusinesses,
    setAffiliatedBusinessesData,
    fetchMerchantData,
    merchantBusinessInfo,
    merchantAndOwners,
  } = useSubmissionStore();
  const [formValid, setFormValid] = useState(false);

  const resetAll = () => {
    // Reset form data to initial empty state
    setFormData({
      id: "",
      businessLegalName: "",
      federalTaxId: "",
      country: selectedCountry || "US",
      address: "",
      city: "",
      state: "",
      zip: "",
      mailingAddress: "",
      mailingCity: "",
      mailingState: "",
      mailingZip: "",
      dba: "",
      legalEntity: "",
      isSeller: false,
      primaryOwner: users.length > 0 ? users[0]?.userId : "",
      accounts: [],
    });

    // Reset all error states
    setErrors({
      businessLegalName: false,
      federalTaxId: false,
      country: false,
      address: false,
      city: false,
      state: false,
      zip: false,
      mailingAddress: false,
      mailingCity: false,
      mailingState: false,
      mailingZip: false,
      dba: false,
      legalEntity: false,
      primaryOwner: false,
    });

    setErrorMessages({
      businessLegalName: "",
      federalTaxId: "",
      country: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      mailingAddress: "",
      mailingCity: "",
      mailingState: "",
      mailingZip: "",
      dba: "",
      legalEntity: "",
      primaryOwner: "",
    });

    setSameAsPhysical(false);
    setFormValid(false);
    handleCloseAccountForm();
  };

  // Validation rules
  const validationRules = {
    businessLegalName: {
      required: true,
      message: "Business legal name is required",
    },
    federalTaxId: {
      required: false,
      pattern: /^\d{2}-\d{7}$/,
      message: "Valid Federal Tax ID (XX-XXXXXXX) is required",
    },
    country: {
      required: false,
      message: "Country is required",
    },
    address: {
      required: false,
      message: "Physical address is required",
    },
    city: {
      required: false,
      message: "City is required",
    },
    state: {
      required: false,
      message: "State is required",
    },
    zip: {
      required: false,
      message: "Valid ZIP/Postal code is required",
    },
    mailingAddress: {
      required: false,
      message: "Mailing address is required",
    },
    mailingCity: {
      required: false,
      message: "Mailing city is required",
    },
    mailingState: {
      required: false,
      message: "Mailing state is required",
    },
    mailingZip: {
      required: false,
      message: "Valid mailing ZIP/Postal code is required",
    },
    dba: {
      required: false,
    },
    legalEntity: {
      required: false,
      message: "Legal entity is required",
    },
    primaryOwner: {
      required: false,
      message: "Primary owner is required",
    },
  };

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id,
        businessLegalName: initialData.businessLegalName || "",
        federalTaxId: initialData.federalTaxId || "",
        country: initialData.abaPhysicalAddress?.country_code || selectedCountry || "US",
        address: initialData.abaPhysicalAddress?.address || "",
        city: initialData.abaPhysicalAddress?.city || "",
        state: String(initialData.abaPhysicalAddress?.state || ""),
        zip: initialData.abaPhysicalAddress?.zipCode || "",
        mailingAddress: initialData.abaMailingAddress?.address || "",
        mailingCity: initialData.abaMailingAddress?.city || "",
        mailingState: String(initialData.abaMailingAddress?.state || ""),
        mailingZip: initialData.abaMailingAddress?.zipCode || "",
        dba: initialData.dbaName || "",
        legalEntity: initialData.legalEntity || "",
        isSeller: initialData.isSeller || false,
        primaryOwner: initialData.userId || (users.length > 0 ? users[0]?.userId : ""),
        accounts: initialData.accounts,
      });
    }
  }, [initialData]);

  useEffect(() => {
    if (merchantAndOwners?.users && merchantAndOwners.users.length > 0) {
      setUsers(merchantAndOwners.users);
      if (merchantAndOwners.users.length > 0) {
        setFormData((prev) => ({
          ...prev,
          primaryOwner: merchantAndOwners.users[0]?.userId,
        }));
      }
    } else if (merchantBusinessInfo?.merchantId) {
      get(`fetchMerchantAndOwners/${merchantBusinessInfo.merchantId}`)
        .then((response) => {
          if (response?.users) {
            setUsers(response.users || []);
            if (response.users.length > 0) {
              setFormData((prev) => ({
                ...prev,
                primaryOwner: response.users[0]?.userId,
              }));
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching users:", error);
        });
    }
  }, [merchantAndOwners, merchantBusinessInfo]);

  useEffect(() => {
    validateForm();
  }, [formData, sameAsPhysical]);

  const validateField = (name: string, value: any) => {
    const rule = validationRules[name as keyof typeof validationRules];
    if (!rule) return true;

    let isValid = true;
    let message = "";

    if (rule.required && !value) {
      isValid = false;
      message = rule.message || `${name} is required`;
    }

    // Special handling for zip/postal code fields
    if ((name === "zip" || name === "mailingZip") && value) {
      const country = formData.country || selectedCountry || "US";
      isValid = validateZipOrPostalCode(value, country);
      if (!isValid) {
        message = country === "CA"
          ? "Valid format: A1A 1A1"
          : "5-digit ZIP code required";
      }
    } else if (value && rule.pattern && !rule.pattern.test(value)) {
      isValid = false;
      message = rule.message || `Invalid ${name}`;
    }

    setErrors((prev) => ({ ...prev, [name]: !isValid }));
    setErrorMessages((prev) => ({ ...prev, [name]: message }));

    return isValid;
  };

  const validateForm = () => {
    let isValid = true;

    Object.keys(validationRules).forEach((field) => {
      const fieldValue = formData[field as keyof typeof formData];
      const fieldValid = validateField(field, fieldValue);
      isValid = isValid && fieldValid;
    });

    setFormValid(isValid);
    return isValid;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === "federalTaxId" || name === "zip" || name === "mailingZip") {
      const numericValue = value.replace(/\D/g, "");
      if (name === "federalTaxId") {
        if (numericValue.length <= 2) {
          setFormData((prev) => ({ ...prev, [name]: numericValue }));
        } else if (numericValue.length <= 9) {
          setFormData((prev) => ({
            ...prev,
            [name]: `${numericValue.slice(0, 2)}-${numericValue.slice(2, 9)}`,
          }));
        }
      } else {
        if (numericValue.length <= 5) {
          setFormData((prev) => ({ ...prev, [name]: numericValue }));
        }
      }
      if (name !== "zip") {
        return;
      }
    }

    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [name]: value,
      };

      if (sameAsPhysical) {
        switch (name) {
          case "address":
            updatedData.mailingAddress = value;
            break;
          case "city":
            updatedData.mailingCity = value;
            break;
          case "state":
            updatedData.mailingState = value;
            break;
          case "zip":
            updatedData.mailingZip = value;
            break;
        }
      }

      return updatedData;
    });
  };

  const handleClose = () => {
    onClose();
    resetAll();
  };

  const handleStateChange = (e: SelectChangeEvent<unknown>, type: "state" | "mailingState") => {
    const { value } = e.target;

    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [type]: value || "",
      };

      if (type === "state" && sameAsPhysical) {
        updatedData.mailingState = value || "";

        setErrors((prevErrors) => ({
          ...prevErrors,
          mailingState: false,
        }));

        setErrorMessages((prevMessages) => ({
          ...prevMessages,
          mailingState: "",
        }));
      }

      return updatedData;
    });
  };

  const handleSelectChange = (e: SelectChangeEvent<unknown>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      isSeller: e.target.checked,
    }));
  };

  const handleCountryChange = (e: SelectChangeEvent<unknown>) => {
    const { value } = e.target;

    setFormData((prev) => ({
      ...prev,
      country: value || "US",
      state: "", // Reset state when country changes
      mailingState: "", // Reset mailing state when country changes
    }));

    // Clear state errors
    setErrors((prev) => ({
      ...prev,
      state: false,
      mailingState: false,
    }));

    setErrorMessages((prev) => ({
      ...prev,
      state: "",
      mailingState: "",
    }));
  };

  const handleSameAsPhysicalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setSameAsPhysical(checked);

    if (checked) {
      setFormData((prev) => ({
        ...prev,
        mailingAddress: prev.address,
        mailingCity: prev.city,
        mailingState: prev.state,
        mailingZip: prev.zip,
      }));

      // Clear errors for mailing address fields
      setErrors((prev) => ({
        ...prev,
        mailingAddress: false,
        mailingCity: false,
        mailingState: false,
        mailingZip: false,
      }));

      setErrorMessages((prev) => ({
        ...prev,
        mailingAddress: "",
        mailingCity: "",
        mailingState: "",
        mailingZip: "",
      }));
    }
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }

    if (users.length === 0) {
      alert("At least one owner is mandatory.");
      return;
    }

    try {
      const requestData = {
        businessLegalName: formData.businessLegalName || "",
        federalTaxId: formData.federalTaxId || "",
        dbaName: formData.dba || "",
        legalEntity: formData.legalEntity || "",
        isSeller: formData.isSeller || "",
        userId: formData.primaryOwner || "",
        abaPhysicalAddress: {
          address: formData.address || "",
          city: formData.city || "",
          state: formData.state || "",
          zipCode: formData.zip || "",
          country_code: formData.country || "US",
        },
        abaMailingAddress: {
          address: formData.mailingAddress || "",
          city: formData.mailingCity || "",
          state: formData.mailingState || "",
          zipCode: formData.mailingZip || "",
          country_code: formData.country || "US",
        },
        accounts: formData.accounts,
        id: formData.id || "",
      };

      const response = await post("/saveOrUpdateAffiliatedBusiness", requestData);
      console.log("API Response:", response);

      if (!response || response.error) {
        console.error("Error saving affiliated business:", response?.error);
        return;
      }

      if (merchantBusinessInfo?.merchantId) {
        fetchMerchantData(merchantBusinessInfo.merchantId);
      }

      onSave(formData);
      onClose();
      resetAll();
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleAccountSave = () => {
    let accounts = formData.accounts || [];

    if (isAccountEditMode) {
      if (currentAccount.accountKey) {
        accounts = accounts.map((acc) =>
          acc.accountKey === currentAccount.accountKey ? currentAccount : acc
        );
      } else {
        accounts = accounts.map((acc, index) =>
          index === accountEditIndex ? currentAccount : acc
        );
      }
    } else {
      accounts.push(currentAccount);
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      accounts: accounts,
    }));

    setShowAccountForm(false);
    setCurrentAccount({});
    setIsAccountEditMode(false);
    setAccountEditIndex(null);
  };

  const handleOpenForm = (account = {}, index = null) => {
    setShowAccountForm(true);
    setCurrentAccount(account);
    setIsAccountEditMode(!!account.accountKey || index !== null);
    setAccountEditIndex(index);
  };

  const handleChangeAccount = (e) => {
    const { name, value } = e.target;
    setCurrentAccount((prev) => ({
      ...(prev || {}),
      [name]: value,
    }));
  };

  const handleCloseAccountForm = () => {
    setShowAccountForm(false);
    setCurrentAccount({});
    setIsAccountEditMode(false);
    setAccountEditIndex(null);
  };

  const handleDeleteAccount = (index) => {
    const existingAccounts = formData?.accounts || [];
    const accounts = existingAccounts.filter((_, accIndex) => accIndex !== index);
    setFormData((prevFormData) => ({
      ...prevFormData,
      accounts: accounts,
    }));
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Affiliated Business
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {/* Row 1: Business Legal Name and Federal Tax ID */}
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Business Legal Name "
                name="businessLegalName"
                value={formData.businessLegalName}
                onChange={handleInputChange}
                onBlur={() => validateField("businessLegalName", formData.businessLegalName)}
                error={errors.businessLegalName}
                helperText={errorMessages.businessLegalName}
                variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Federal Tax ID"
                name="federalTaxId"
                value={formData.federalTaxId}
                onChange={handleInputChange}
                onBlur={() => validateField("federalTaxId", formData.federalTaxId)}
                error={errors.federalTaxId}
                helperText={errorMessages.federalTaxId}
                variant="standard"
              />
            </Grid>

            {/* Row 2: Country and Address */}
            <Grid item xs={3}>
              <FormControl fullWidth variant="standard" sx={{ mt: 0 }} error={errors.country}>
                <InputLabel>Country *</InputLabel>
                <Select
                  label="Country"
                  value={formData.country || ""}
                  onChange={(e) => {
                    handleCountryChange(e);
                    validateField("country", e.target.value);
                  }}
                  name="country"
                  sx={{
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                      },
                    },
                  }}
                  onOpen={() => setCountryDropdownOpen(true)}
                  onClose={() => setCountryDropdownOpen(false)}
                  endAdornment={countryDropdownOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                >
                  {countries.map((country) => (
                    <MenuItem key={country.value} value={country.value}>
                      {country.label}
                    </MenuItem>
                  ))}
                </Select>
                {errors.country && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ fontSize: "0.75rem", marginLeft: "14px" }}
                  >
                    {errorMessages.country}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                label="Physical Address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                onBlur={() => validateField("address", formData.address)}
                error={errors.address}
                helperText={errorMessages.address}
                variant="standard"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="City"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                onBlur={() => validateField("city", formData.city)}
                error={errors.city}
                helperText={errorMessages.city}
                variant="standard"
              />
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth variant="standard" sx={{ mt: 0 }} error={errors.state}>
                <InputLabel>{getStateProvinceLabel(formData.country)} *</InputLabel>
                <Select
                  label="State"
                  value={formData.state || ""}
                  onChange={(e) => {
                    handleStateChange(e, "state");
                    validateField("state", e.target.value);
                  }}
                  name="state"
                  sx={{
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                      },
                    },
                  }}
                  onOpen={() => setStateDropdownOpen(true)}
                  onClose={() => setStateDropdownOpen(false)}
                  endAdornment={stateDropdownOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                >
                  {getStatesProvinces(formData.country).map((state) => (
                    <MenuItem key={state.value} value={state.value}>
                      {state.label} ({state.short})
                    </MenuItem>
                  ))}
                </Select>
                {errors.state && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ fontSize: "0.75rem", marginLeft: "14px" }}
                  >
                    {errorMessages.state}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label={getZipPostalLabel(formData.country)}
                name="zip"
                value={formData.zip}
                onChange={handleInputChange}
                onBlur={() => validateField("zip", formData.zip)}
                error={errors.zip}
                helperText={errorMessages.zip}
                variant="standard"
                inputProps={{
                  maxLength: 5,
                }}
              />
            </Grid>

            {/* Checkbox for "Same as Physical Address" */}
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Box sx={{ fontWeight: "bold", marginBottom: "-30px", marginTop: "-25px" }}>
                <FormControlLabel
                  control={
                    <Checkbox checked={sameAsPhysical} onChange={handleSameAsPhysicalChange} />
                  }
                  label="Mailing Address Same as Physical"
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Mailing Address"
                name="mailingAddress"
                value={formData.mailingAddress}
                onChange={handleInputChange}
                onBlur={() => validateField("mailingAddress", formData.mailingAddress)}
                error={errors.mailingAddress}
                helperText={errorMessages.mailingAddress}
                variant="standard"
                disabled={sameAsPhysical}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label="Mailing City"
                name="mailingCity"
                value={formData.mailingCity}
                onChange={handleInputChange}
                onBlur={() => validateField("mailingCity", formData.mailingCity)}
                error={errors.mailingCity}
                helperText={errorMessages.mailingCity}
                variant="standard"
                disabled={sameAsPhysical}
              />
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth variant="standard" error={errors.mailingState}>
                <InputLabel>Mailing {getStateProvinceLabel(formData.country)} *</InputLabel>
                <Select
                  label="Mailing State"
                  value={formData.mailingState}
                  onChange={(e) => {
                    handleStateChange(e, "mailingState");
                    validateField("mailingState", e.target.value);
                  }}
                  name="mailingState"
                  sx={{
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                      },
                    },
                  }}
                  onOpen={() => setMailingStateDropdownOpen(true)}
                  onClose={() => setMailingStateDropdownOpen(false)}
                  endAdornment={
                    mailingStateDropdownOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />
                  }
                  disabled={sameAsPhysical}
                >
                  {getStatesProvinces(formData.country).map((state) => (
                    <MenuItem key={state.value} value={state.value}>
                      {state.label} ({state.short})
                    </MenuItem>
                  ))}
                </Select>
                {errors.mailingState && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ fontSize: "0.75rem", marginLeft: "14px" }}
                  >
                    {errorMessages.mailingState}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                label={`Mailing ${getZipPostalLabel(formData.country)}`}
                name="mailingZip"
                value={formData.mailingZip}
                onChange={handleInputChange}
                onBlur={() => validateField("mailingZip", formData.mailingZip)}
                error={errors.mailingZip}
                helperText={errorMessages.mailingZip}
                variant="standard"
                disabled={sameAsPhysical}
                inputProps={{
                  maxLength: 5,
                }}
              />
            </Grid>

            {/* Row 4: D/B/A, Legal Entity (dropdown), Primary Owner, Is Seller checkbox */}
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="D/B/A"
                name="dba"
                value={formData.dba}
                onChange={handleInputChange}
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl fullWidth variant="standard" error={errors.legalEntity}>
                <InputLabel>Legal Entity</InputLabel>
                <Select
                  label="Legal Entity"
                  value={formData.legalEntity || ""}
                  onChange={(e) => {
                    handleSelectChange(e);
                    validateField("legalEntity", e.target.value);
                  }}
                  name="legalEntity"
                  sx={{ height: "30px", display: "flex", alignItems: "center" }}
                  endAdornment={
                    primaryOwnerDropdownOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />
                  }
                >
                  <MenuItem value="Corporation">Corporation</MenuItem>
                  <MenuItem value="Limited Liability Company">Limited Liability Company</MenuItem>
                  <MenuItem value="Limited Partnership">Limited Partnership</MenuItem>
                  <MenuItem value="Limited Liability Partnership">
                    Limited Liability Partnership
                  </MenuItem>
                  <MenuItem value="Sole Proprietor">Sole Proprietor</MenuItem>
                </Select>
                {errors.legalEntity && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ fontSize: "0.75rem", marginLeft: "14px" }}
                  >
                    {errorMessages.legalEntity}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <FormControl fullWidth variant="standard" error={errors.primaryOwner}>
                <InputLabel>Primary Owner *</InputLabel>
                <Select
                  label="Primary Owner"
                  value={formData.primaryOwner}
                  onChange={(e) => {
                    handleSelectChange(e);
                    validateField("primaryOwner", e.target.value);
                  }}
                  name="primaryOwner"
                  sx={{
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                      },
                    },
                  }}
                  endAdornment={
                    primaryOwnerDropdownOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />
                  }
                >
                  {users.map((user) => (
                    <MenuItem key={user.userId} value={user.userId}>
                      {user.firstName} {user.lastName}
                    </MenuItem>
                  ))}
                </Select>
                {errors.primaryOwner && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ fontSize: "0.75rem", marginLeft: "14px" }}
                  >
                    {errorMessages.primaryOwner}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                control={<Checkbox checked={formData.isSeller} onChange={handleCheckboxChange} />}
                label="Is Seller"
                sx={{ height: "70px", display: "flex", alignItems: "center", marginLeft: "20px" }}
              />
            </Grid>
          </Grid>

          <Grid container id="collection-accounts-tab" sx={{ ml: "10px" }}>
            <Grid item xs={12}>
              <Grid container>
                <Typography
                  sx={{
                    mb: "10px",
                    mt: "10px",
                    fontWeight: "bold",
                    color: "#132A5B",
                    fontSize: "14px",
                  }}
                >
                  ACCOUNTS
                </Typography>
              </Grid>

              <Grid container>
                <MDButton
                  variant="outlined"
                  size="small"
                  color="primary"
                  startIcon={<i className="fa fa-plus" />}
                  onClick={() => handleOpenForm()}
                >
                  Add Account
                </MDButton>
              </Grid>

              {showAccountForm && (
                <Grid container alignItems="center" spacing={2} sx={{ mt: "10px", mb: "10px" }}>
                  <Grid item>
                    <TextField
                      size="small"
                      name="accountName"
                      placeholder="Account Name"
                      value={currentAccount.accountName || ""}
                      onChange={handleChangeAccount}
                      type="text"
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item>
                    <TextField
                      size="small"
                      name="bankName"
                      placeholder="Bank Name"
                      value={currentAccount.bankName || ""}
                      onChange={handleChangeAccount}
                      type="text"
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item>
                    <TextField
                      size="small"
                      name="accountNumber"
                      placeholder="Account Number"
                      value={currentAccount.accountNumber || ""}
                      onChange={handleChangeAccount}
                      type="number"
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item>
                    <TextField
                      size="small"
                      name="abaNumber"
                      placeholder="ABA Number"
                      value={currentAccount.abaNumber || ""}
                      onChange={handleChangeAccount}
                      type="number"
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item>
                    <Tooltip title="Add Account">
                      <i
                        className="fa fa-plus"
                        style={{
                          cursor: "pointer",
                          color: "#28a745",
                          fontSize: "20px",
                          marginRight: "16px",
                        }}
                        onClick={handleAccountSave}
                      />
                    </Tooltip>
                    <Tooltip title="Cancel">
                      <i
                        className="fa fa-times"
                        style={{
                          cursor: "pointer",
                          color: "#dc3545",
                          fontSize: "20px",
                        }}
                        onClick={handleCloseAccountForm}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              )}

              {formData?.accounts && formData.accounts.length > 0 && (
                <>
                  <Grid
                    container
                    alignItems="center"
                    sx={{
                      mt: 2,
                      pb: 1,
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <Grid item md={2}>
                      <MDTypography variant="body2" sx={{ fontWeight: 500, fontSize: "0.875rem" }}>
                        Account Name
                      </MDTypography>
                    </Grid>
                    <Grid item md={2}>
                      <MDTypography variant="body2" sx={{ fontWeight: 500, fontSize: "0.875rem" }}>
                        Bank Name
                      </MDTypography>
                    </Grid>
                    <Grid item md={2}>
                      <MDTypography variant="body2" sx={{ fontWeight: 500, fontSize: "0.875rem" }}>
                        Account Number
                      </MDTypography>
                    </Grid>
                    <Grid item md={2}>
                      <MDTypography variant="body2" sx={{ fontWeight: 500, fontSize: "0.875rem" }}>
                        ABA Number
                      </MDTypography>
                    </Grid>
                    <Grid item md={4}>
                      <MDTypography
                        variant="body2"
                        sx={{ fontWeight: 500, fontSize: "0.875rem", marginLeft: 3 }}
                      >
                        Actions
                      </MDTypography>
                    </Grid>
                  </Grid>

                  {formData.accounts.map((account, index) => (
                    <Grid container key={index} alignItems="center" spacing={2} sx={{ mt: 1 }}>
                      <Grid item md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          name="accountName"
                          value={account.accountName || ""}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          name="bankName"
                          value={account.bankName || ""}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid item md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          name="accountNumber"
                          value={account.accountNumber || ""}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid item md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          name="abaNumber"
                          value={account.abaNumber || ""}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>

                      <Grid item md={4}>
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ ml: 1 }}>
                          <Tooltip title="Edit Account">
                            <IconButton
                              onClick={() => handleOpenForm(account, index)}
                              sx={{ color: "#2F929F" }}
                              aria-label="edit-account"
                              size="small"
                            >
                              <i className="fa fa-edit" style={{ fontSize: "18px" }} />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Remove Account">
                            <IconButton
                              onClick={() => handleDeleteAccount(index)}
                              sx={{ color: "#dc3545" }}
                              aria-label="delete-account"
                              size="small"
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </Grid>
                    </Grid>
                  ))}
                </>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#333",
              color: "#fff",
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <MDButton variant="gradient" color="primary" onClick={handleSave} disabled={!formValid}>
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AffiliatedBusinessForm;
